export const DOCUMENTS_TAB_ACTIONS = {
  'SET_STATE': 'DOCUMENTS_TAB_SET_STATE',
  'SET_FINAL': 'DOCUMENTS_TAB_SET_FINAL',
  'SET_ADDENDUM': 'DOCUMENTS_TAB_SET_ADDENDUM',
  'INIT_REVIEWS': 'DOCUMENTS_TAB_INIT_REVIEWS',
  'SET_SUMMARIES': 'DOCUMENTS_TAB_SET_SUMMARIES'
};
